const dataDelivery = {
  title: 'Detalii Livrare',
  description: [
    'Flori Camelia livrează buchete de flori, aranjamente florale și cadouri în orașul Drochia și împrejurimi în raza de __km.',
    'Fie că sunteți acasă sau departe, dăruiți celor dragi un buchet de flori superbe pentru a-i surprinde.',
    'Avem flori pentru diverse ocazii, vorbiți cu noi despre ocazia dvs. și împreună vom alege florile potrivite.'
  ],
  footerNotes: '<p>Sunați-ne acum și cereți o comandă <a href=\'tel:\'>+373 676 17 827</a>.</p>'
};

export default dataDelivery;
